import {
  alertRedBg,
  auroMetalSaurus,
  azureLight,
  background,
  backgroundGrey,
  black,
  blue,
  blueCharcoal,
  blueLightGrey,
  breakerBay,
  cherryRed,
  darkerGrey,
  darkerOrange,
  darkGrey,
  darkMildGray,
  darkPink,
  deepAmethyst,
  dustyGray,
  fucsia,
  gallery,
  green,
  greenBlue,
  grey,
  lightBlue,
  lighterBlue,
  lighterGrey,
  lighterMidBlue,
  lightGray,
  lightGrey,
  lightMildGray,
  lightPaleGrey,
  lightPink,
  lightPurple,
  lilac,
  midBlue,
  midDarkGray,
  midGray,
  midGreen,
  midHeavyGray,
  midLighterGray,
  midLightGray,
  midLowGray,
  midRed,
  mildDarkGray,
  mildGray,
  navbarActiveColor,
  navbarElementBorderBottom,
  newYellow,
  newYorkPink,
  offWhite,
  orange,
  paleGrey,
  paleLavender,
  pink,
  porsche,
  purple,
  quartz,
  reddishPink,
  someOtherBlue,
  stripeEnabled,
  strongPink,
  successGreen,
  tanLight,
  textDarkGrey,
  textGrey,
  theOtherGrey,
  tiffany,
  transparentColor,
  violetPurple,
  warningOrange,
  whisper,
  white,
  whiteBoxShadow,
  wildSand,
  wisteria,
  yellow,
  yellowOrange,
} from 'consts/colors';
import {
  STATUS_ACTIVE,
  STATUS_ASSIGNED,
  STATUS_AUTHORIZED,
  STATUS_AVAILABLE,
  STATUS_BLOCK,
  STATUS_BLOCKED,
  STATUS_BURNT,
  STATUS_CHARGING,
  STATUS_CLOSED,
  STATUS_DEACTIVE,
  STATUS_DELETED,
  STATUS_DISCARDED,
  STATUS_DISMISSED,
  STATUS_ELABORATED,
  STATUS_ENABLED,
  STATUS_EXPIRED,
  STATUS_FAULTED,
  STATUS_FINISHED,
  STATUS_FINISHING,
  STATUS_INACTIVE,
  STATUS_INSTALLED,
  STATUS_NOT_ACTIVE,
  STATUS_NOT_AVAILABLE,
  STATUS_NOTDISMISSED,
  STATUS_OCCUPIED,
  STATUS_OFFLINE,
  STATUS_ONGOING,
  STATUS_OPEN,
  STATUS_PARTIALFAULTED,
  STATUS_PARTIALOCCUPIED,
  STATUS_PENDING,
  STATUS_PLANNED,
  STATUS_PLUGGEDIN,
  STATUS_PRE_ACTIVATED,
  STATUS_PRE_ACTIVE,
  STATUS_PREPARING,
  STATUS_PROCESSING,
  STATUS_PUBLISHED,
  STATUS_REACHABLE,
  STATUS_RESERVED,
  STATUS_STANDALONE,
  STATUS_STANDBYCS,
  STATUS_STANDBYVEHICLE,
  STATUS_SUSPENDED,
  STATUS_SUSPENDEDEV,
  STATUS_SUSPENDEDEVSE,
  STATUS_SWITCHEDOFF,
  STATUS_TEMPORARY_NOT_AVAILABLE,
  STATUS_UNAVAILABLE,
  STATUS_UNREACHABLE,
} from 'consts/status';

export const theme = {
  version: '0.0.3',
  colors: {
    accent: {
      primary: purple,
    },
    primary: {
      alertRedBg,
      background,
      black,
      blueLightGrey,
      darkGrey,
      grey,
      lighterGrey,
      lightGrey,
      lighterMidBlue,
      lighterBlue,
      lilac,
      navbarActiveColor,
      navbarElementBorderBottom,
      orange,
      purple,
      reddishPink,
      strongPink,
      tanLight,
      textDarkGrey,
      textGrey,
      violetPurple,
      white,
      whiteBoxShadow,
      yellowOrange,
      transparentColor,
      midBlue,
      midRed,
      midGreen,
    },
    status: {
      black,
      blue,
      cherryRed,
      darkerGrey,
      darkerOrange,
      green,
      greenBlue,
      grey,
      lightBlue,
      newYellow,
      orange,
      pink,
      purple,
      someOtherBlue,
      stripeEnabled,
      successGreen,
      theOtherGrey,
      violetPurple,
      warningOrange,
      yellow,
      [STATUS_ACTIVE]: green,
      [STATUS_ASSIGNED]: black,
      [STATUS_AUTHORIZED]: green,
      [STATUS_AVAILABLE]: green,
      [STATUS_BLOCK]: black,
      [STATUS_BLOCKED]: black,
      [STATUS_BURNT]: black,
      [STATUS_CHARGING]: violetPurple,
      [STATUS_CLOSED]: black,
      [STATUS_DEACTIVE]: black,
      [STATUS_DELETED]: black,
      [STATUS_DISCARDED]: black,
      [STATUS_DISMISSED]: theOtherGrey,
      [STATUS_ELABORATED]: black,
      [STATUS_ENABLED]: black,
      [STATUS_EXPIRED]: black,
      [STATUS_FAULTED]: cherryRed,
      [STATUS_FINISHED]: violetPurple,
      [STATUS_FINISHING]: violetPurple,
      [STATUS_INACTIVE]: darkerGrey,
      [STATUS_INSTALLED]: someOtherBlue,
      [STATUS_NOT_ACTIVE]: black,
      [STATUS_NOT_AVAILABLE]: black,
      [STATUS_NOTDISMISSED]: darkerGrey,
      [STATUS_OCCUPIED]: darkerOrange,
      [STATUS_OFFLINE]: grey,
      [STATUS_ONGOING]: black,
      [STATUS_OPEN]: black,
      [STATUS_PARTIALFAULTED]: strongPink,
      [STATUS_PARTIALOCCUPIED]: cherryRed,
      [STATUS_PENDING]: black,
      [STATUS_PLANNED]: violetPurple,
      [STATUS_PLUGGEDIN]: violetPurple,
      [STATUS_PRE_ACTIVATED]: black,
      [STATUS_PRE_ACTIVE]: black,
      [STATUS_PREPARING]: violetPurple,
      [STATUS_PROCESSING]: black,
      [STATUS_PUBLISHED]: lightBlue,
      [STATUS_REACHABLE]: black,
      [STATUS_RESERVED]: violetPurple,
      [STATUS_STANDALONE]: violetPurple,
      [STATUS_STANDBYCS]: black,
      [STATUS_STANDBYVEHICLE]: black,
      [STATUS_SUSPENDED]: black,
      [STATUS_SUSPENDEDEV]: violetPurple,
      [STATUS_SUSPENDEDEVSE]: violetPurple,
      [STATUS_SWITCHEDOFF]: darkerGrey,
      [STATUS_TEMPORARY_NOT_AVAILABLE]: black,
      [STATUS_UNAVAILABLE]: darkerGrey,
      [STATUS_UNREACHABLE]: darkerGrey,
    },
    rfid: {
      [STATUS_ACTIVE]: green,
      [STATUS_INACTIVE]: darkerGrey,
      [STATUS_BLOCK]: cherryRed,
      [STATUS_BLOCKED]: cherryRed,
      [STATUS_PRE_ACTIVE]: violetPurple,
      [STATUS_AUTHORIZED]: strongPink,
      [STATUS_FINISHED]: violetPurple,
    },
    report: {
      [STATUS_ENABLED]: green,
      [STATUS_SUSPENDED]: yellow,
      [STATUS_EXPIRED]: grey,
    },
    graph: {
      azureLight,
      blue,
      darkPink,
      fucsia,
      green,
      lightBlue,
      orange,
      purple,
      textGrey,
      yellow,
      colorBar1: breakerBay,
      colorBar2: newYorkPink,
      colorBar3: porsche,
      colorBar4: deepAmethyst,
      colorBar5: auroMetalSaurus,
      backgroundGrid: mildGray,
    },
    notifications: {
      lightPurple,
      lightPink,
    },
    custom: {
      blueCharcoal,
      darkGrey: quartz,
      dustyGray,
      gallery,
      grey: dustyGray,
      lighterGrey: dustyGray,
      lightGrey,
      lightPaleGrey,
      backgroundGrey,
      offWhite,
      paleGrey,
      paleLavender,
      tiffany,
      whisper,
      wildSand,
      wisteria,
    },
    widget: {
      borderColor: paleGrey,
      boxShadow: blueLightGrey,
    },
  },
  fontset: 'RoobertEnel, sans-serif',
  zIndex: {
    header: 5000,
    notifyManager: 9002,
    loader: 4999,
    loaderModal: 7001,
    absoluteUp: 9999,
  },
  config: {
    changePasswordBg: '/assets/change-password.png',
    changePasswordLogo: '/assets/logo_enel_white.svg',
    errorPageLogo: '/assets/logo_enel_colored.svg',
    headerLogo: '/assets/logo_enel_white.svg',
    mobileHeaderLogo: '/assets/logo_enelx_white_mobile.svg',
    userNotAuthorizedLogo: '/assets/logo_enel_colored.svg',
    wizardLogo: '/assets/logo_enel_colored.svg',
  },
  footer: {
    shadowColor: mildGray,
  },
  input: {
    singleInput: {
      borderColor: grey,
      backgroundColor: white,
      placeholderColor: textGrey,
      passwordColor: purple,
    },
  },
  searchbar: {
    sizes: {
      gap: '12px',
      borderRadius: '4px',
      padding: '16px',
    },
  },
  map: {
    tooltip: {
      colorText: navbarActiveColor,
      boxShadow: midHeavyGray,
    },
    geometryColor: wildSand,
    labelsTextFill: mildDarkGray,
    labelsTextStroke: wildSand,
    labelsTextFillAdministrative: darkMildGray,
    geometryPoi: lightGray,
    geometryPoiTextField: midGray,
    geometryPark: lightMildGray,
    geometryParkTextField: midDarkGray,
    road: white,
    roadArterial: midGray,
    roadHighway: midLightGray,
    roadHighwayText: mildDarkGray,
    roadLocal: midDarkGray,
    geometryTransitLine: lightMildGray,
    geometryTransitStation: lightGray,
    water: midLowGray,
    waterText: midDarkGray,
  },
  scrollbar: {
    color: midLighterGray,
    hoverColor: darkGrey,
  },
};

export default theme;
